import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { WORK } from "../data/work";
import BrandMark from "./BrandMark";

const WorkRow = ({ item, index }) => (
  <Reveal delay={(index % 2) * 0.05} className="border-b border-line">
    <Link
      to={`/work/${item.slug}`}
      data-testid={`work-card-${item.slug}`}
      className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-7 md:py-9 items-center"
    >
      {/* Left — thumbnail (uniform size for every case) */}
      <div className="md:col-span-5 lg:col-span-4">
        <div className="relative overflow-hidden aspect-[4/3] bg-ink/[0.03]">
          <div className="w-full h-full transition-transform duration-700 ease-out group-hover:scale-[1.03]">
            <BrandMark slug={item.slug} />
          </div>
        </div>
      </div>

      {/* Right — descriptor line */}
      <div className="md:col-span-7 lg:col-span-8 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-3 sm:gap-8">
        <div className="min-w-0">
          <div className="flex items-baseline gap-4">
            <span className="font-serif text-base md:text-lg text-vermilion">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h3 className="font-serif text-3xl md:text-5xl text-ink leading-[1.02] group-hover:text-vermilion transition-colors duration-300">
              {item.title}
            </h3>
          </div>
          <p className="mt-3 md:ml-9 font-serif italic text-lg md:text-2xl text-ink/70">
            “{item.tagline}”
          </p>
          <p className="mt-2 md:ml-9 text-sm text-muted2">{item.discipline}</p>
        </div>

        <div className="flex items-center gap-6 shrink-0 md:pt-2">
          <span className="text-sm text-muted2 whitespace-nowrap">{item.year}</span>
          <span className="text-xl text-vermilion translate-x-[-6px] opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
            ↗
          </span>
        </div>
      </div>
    </Link>
  </Reveal>
);

export default function WorkGrid() {
  return (
    <section
      id="work"
      data-testid="work-section"
      className="px-5 md:px-12 py-20 md:py-28 max-w-[1600px] mx-auto scroll-mt-20"
    >
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14 md:mb-20">
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1]">
          The noticeable ones.
        </h2>
        <p className="max-w-sm text-muted2 text-base">
          Six years of brands, launches and lines, from Rapido’s Ownly to a
          fragrance house of my own.
        </p>
      </Reveal>

      <div className="border-t border-line">
        {WORK.map((item, i) => (
          <WorkRow key={item.slug} item={item} index={i} />
        ))}
      </div>
    </section>
  );
}
